let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cgdgo")).then(() => parcelRequire('7OKK3'));